// #region imports

// --- Angular
import { Component, OnInit, Input } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {

  @Input() cardStyle = false;
  @Input() progress: number;

  constructor() { }

  ngOnInit() {
  }

}
